module.exports = __webpack_public_path__ + "img/logo_ps.c4b29bde.png";